import React, { PureComponent } from 'react'
import { translate } from 'react-polyglot'
import axios from 'axios'
import classNames from 'classnames'

import './image.scss'

class Image extends PureComponent {
	state = {
		src: null,
		isLoading: false,
		progress: null,
	}

	config = {
		onUploadProgress: progressEvent => {
			const progress = Math.round(
				(progressEvent.loaded * 100) / progressEvent.total
			)

			this.setState({ progress })
		},
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	}

	componentDidMount() {
		const {
			node: { data },
		} = this.props

		// If its an external image (f. ex. `Getting started` images)
		// do not upload/load from API
		if (data.get('url')) return false

		const id = data.get('id')
		const formData = data.get('formData')

		if (formData || (formData && formData.size !== 0)) {
			this.onUpload(formData)
		} else if (id) {
			this.onLoad(id)
		}
	}

	onLoad = id => {
		this.setState({ isLoading: true })

		axios
			.get(`files/${id}?media`)
			.then(response => {
				this.setState({
					isLoading: false,
					src: response.data,
				})
			})
			.catch(error => console.log(error))
	}

	onUpload = formData => {
		axios
			.post('files', formData, this.config)
			.then(response => {
				const {
					editor,
					node,
					node: { data },
				} = this.props

				const name = data.get('name')

				editor.setNodeByKey(node.key, {
					type: 'image',
					data: {
						id: response.data.id,
						name,
						height: response.data.height,
						width: response.data.width,
					},
				})

				this.onLoad(response.data.id)
			})
			.catch(error => console.log(error))
	}

	render() {
		let { progress, src, isLoading } = this.state

		const {
			attributes,
			node: { data },
			t,
		} = this.props

		const url = data.get('url')

		const height = data.get('height') || 'auto'
		const width = data.get('width') || 'auto'
		const ratio = data.get('height') ? `${(height / width) * 100}%` : null
		const percentage = `${100 - parseInt(progress, 10)}%`

		let isUploading = !data.get('id')

		if (url || (data.get('src') && !src)) {
			src = url || data.get('src')
			progress = 100
			isLoading = false
			isUploading = false
		}

		return (
			<div
				{...attributes}
				className={classNames(
					attributes.className,
					'c-image',
					{ 'is-uploading': isUploading },
					{ 'is-loading': isLoading }
				)}
				style={{ width }}
			>
				<div
					className="c-image__inner"
					style={{
						paddingBottom: ratio || 0,
						height: ratio ? 0 : 'auto',
					}}
				>
					<div
						className="c-image__uploading"
						style={{ backgroundPosition: percentage }}
					>
						{isLoading || progress === 100 ? (
							<span>
								<span className="c-image__spinner" />
								<span>{t('editor.generating_preview')}</span>
							</span>
						) : null}
						{isUploading && progress < 100 && (
							<span>{progress || 0} %</span>
						)}
					</div>

					<div
						className="c-image__item"
						style={{ position: ratio ? 'absolute' : 'relative' }}
					>
						{src && src.substring(0, 4) === 'SVG|' ? (
							<div
								dangerouslySetInnerHTML={{
									__html: src.substring(4, src.length),
								}}
							/>
						) : (
							<img
								src={src}
								style={{
									position: ratio ? 'absolute' : 'relative',
								}}
								alt=""
							/>
						)}
					</div>
				</div>
			</div>
		)
	}
}

export default translate()(Image)
